var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBundles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9036 8.92904C12.1142 9.02266 12.25 9.23157 12.25 9.4621V14.5731C12.25 14.7849 12.1351 14.9801 11.95 15.083L7.28329 17.6756C7.10711 17.7735 6.89289 17.7735 6.71671 17.6756L2.05004 15.083C1.86485 14.9801 1.75 14.7849 1.75 14.5731V9.4621C1.75 9.23157 1.88576 9.02266 2.09642 8.92904L6.76309 6.85496C6.91392 6.78793 7.08608 6.78793 7.23691 6.85496L11.9036 8.92904Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7311 7.46387L4.43359 9.85137V12.5279L5.60026 13.1113V10.5378L10.0657 8.05703L8.7311 7.46387Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9036 16.929C23.1142 17.0227 23.25 17.2316 23.25 17.4621V22.5731C23.25 22.7849 23.1351 22.9801 22.95 23.083L18.2833 25.6756C18.1071 25.7735 17.8929 25.7735 17.7167 25.6756L13.05 23.083C12.8649 22.9801 12.75 22.7849 12.75 22.5731V17.4621C12.75 17.2316 12.8858 17.0227 13.0964 16.929L17.7631 14.855C17.9139 14.7879 18.0861 14.7879 18.2369 14.855L22.9036 16.929Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7311 15.4639L15.4336 17.8514V20.5279L16.6003 21.1113V18.5378L21.0657 16.057L19.7311 15.4639Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9036 3.92904C25.1142 4.02266 25.25 4.23157 25.25 4.4621V9.5731C25.25 9.78495 25.1351 9.98014 24.95 10.083L20.2833 12.6756C20.1071 12.7735 19.8929 12.7735 19.7167 12.6756L15.05 10.083C14.8649 9.98014 14.75 9.78495 14.75 9.5731V4.4621C14.75 4.23157 14.8858 4.02266 15.0964 3.92904L19.7631 1.85496C19.9139 1.78793 20.0861 1.78793 20.2369 1.85496L24.9036 3.92904Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7311 2.46387L17.4336 4.85137V7.52794L18.6003 8.11127V5.53784L23.0657 3.05703L21.7311 2.46387Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundles);
export default __webpack_public_path__ + "static/media/bundles.fa876794dfee713e471b31bf6ca85d3e.svg";
export { ForwardRef as ReactComponent };